{
  "name": "41-(13-Limit) Breed",
  "description": "Graham Breed's 41-tone 13-Limit Rational Intonation scale, consisting of 41 notes per octave derived from harmonic partial row intervals up to a prime limit of 13. This 13-Limit scale demonstrates an asymmetric harmonic and partially-subharmonic construction producing a continuous chain of perfect fifths and \"quasi-fifths\". By its similarity to the other 41-tone scales found here, this version demonstrates the concept of \"rational temperament\", where enharmonically proximal ratios may substitute for missing notes as slightly mistuned alternates. Compare this tuning to 41edo temperament.",
  "scale": [
    "81/80",
    "33/32",
    "135/128",
    "16/15",
    "13/12",
    "10/9",
    "9/8",
    "8/7",
    "7/6",
    "1215/1024",
    "6/5",
    "39/32",
    "5/4",
    "81/64",
    "9/7",
    "21/16",
    "4/3",
    "27/20",
    "11/8",
    "45/32",
    "729/512",
    "13/9",
    "189/128",
    "3/2",
    "243/160",
    "99/64",
    "405/256",
    "8/5",
    "13/8",
    "5/3",
    "27/16",
    "12/7",
    "7/4",
    "16/9",
    "9/5",
    "11/6",
    "15/8",
    "243/128",
    "27/14",
    "63/32",
    "2/1"
  ],
  "key_colors_mode": "manual",
  "short_description": "41-JI-13L(Breed)",
  "built_in_group": "Rational Intonation (JI)",
  "key_labels": "note_names",
  "fundamental_color": "#ffdbe8",
  "note_names": [
    "*nC",
    "C",
    "C",
    "C",
    "D",
    "D",
    "D",
    "*nD",
    "D",
    "E",
    "D",
    "E",
    "E",
    "E",
    "*nE",
    "E",
    "F",
    "*nF",
    "F",
    "F",
    "F",
    "F",
    "G",
    "G",
    "*nG",
    "G",
    "G",
    "G",
    "A",
    "A",
    "A",
    "A",
    "A",
    "B",
    "B",
    "B",
    "B",
    "B",
    "B",
    "B",
    "C"
  ],
  "note_colors": [
    "#ffffff",
    "#dee2da",
    "#dfffd6",
    "#eee9d3",
    "#dee2da",
    "#e6d7fe",
    "#fffae5",
    "#ffffff",
    "#e2caca",
    "#ffe5e5",
    "#eee9d3",
    "#dee2da",
    "#e6d7fe",
    "#fffae5",
    "#ffffff",
    "#e2caca",
    "#ffe5e5",
    "#ffffff",
    "#dee2da",
    "#dfffd6",
    "#eee9d3",
    "#d0d0d7",
    "#e6d7fe",
    "#ffe5e5",
    "#ffffff",
    "#dee2da",
    "#dfffd6",
    "#eee9d3",
    "#dee2da",
    "#e6d7fe",
    "#fffae5",
    "#ffffff",
    "#e2caca",
    "#ffe5e5",
    "#d0d0d7",
    "#dee2da",
    "#dfffd6",
    "#fffae5",
    "#ffffff",
    "#e2caca",
    "#ffe5e5"
  ],
  "equivSteps": 41,
  "fundamental": 440,
  "reference_degree": 31,
  "center_degree": 0,
  "rSteps": 7,
  "drSteps": 3,
  "hexSize": 42,
  "rotation": -16.102113751
}
